<div class="menu-item" [ngClass]="{ 'text-danger': item.visible === 0 }">

  <div class="menu-header w-100 d-flex justify-content-between">
    <div>
      {{ item.title }}
      <button class="btn" *ngIf="item.children?.length" (click)="showChildren = !showChildren">
        <i class="fi fi-rr-add d-flex align-items-center" *ngIf="!showChildren"></i>
        <i class="fi fi-rr-minus-circle d-flex align-items-center" *ngIf="showChildren"></i>
      </button>
    </div>

   <div class="d-flex align-items-center gap-2">

      <!-- Link button -->
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary"
        *ngIf="canHaveLink(item)"
        (click)="openLink(item)"
        title="ბმულის გახსნა"
      >
        <i class="fi fi-br-link-alt"></i>
      </button>

      <!-- Visible toggle (variant B: button + loading) -->
      <button
        type="button"
        class="btn btn-sm btn-light visibility-btn"
        [class.is-hidden]="item.visible === 0"
        [disabled]="isTogglingVisible"
        (click)="toggleVisible()"
        title="დამალვა / ჩართვა"
      >
        <span *ngIf="isTogglingVisible" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

        <ng-container *ngIf="!isTogglingVisible">
          <i class="fi fi-rs-eye" *ngIf="item.visible !== 0"></i>
          <i class="fi fi-rr-eye-crossed" *ngIf="item.visible === 0"></i>
        </ng-container>
      </button>

      <!-- Edit -->
      <button type="button" class="btn btn-sm btn-primary" (click)="openEditModal()" title="რედაქტირება" *ngIf="admin.hasPermission('menus_edit')"
>
        <i class="fi fi-rr-edit"></i>
      </button>

      <!-- Delete -->
      <button type="button" class="btn btn-sm btn-danger" (click)="deleteItem()" title="წაშლა" *ngIf="admin.hasPermission('menus_delete')">
        <i class="fi fi-rr-trash"></i>
      </button>
    </div>
  </div>

  <!-- CHILDREN -->
  <div
    class="children"
    *ngIf="showChildren"
    cdkDropList
    [cdkDropListData]="item.children"
    (cdkDropListDropped)="dropChild($event)"
  >
    <div
      class="menu-drag-container child-drag"
      *ngFor="let child of item.children"
      cdkDrag
    >
      <div cdkDragHandle class="drag-handle"><i class="fi fi-rr-arrows"></i></div>

      <!-- Recursive app-menu-item -->
      <app-menu-item
        [item]="child"
        [allMenu]="allMenu"
        (update)="update.emit()"
        (dragChanged)="dragChanged.emit($event)"
      ></app-menu-item>

      <ng-template cdkDragPlaceholder>
        <div class="menu-drag-container drag-placeholder"></div>
      </ng-template>
    </div>
  </div>

</div>